module.exports = __webpack_public_path__ + "img/材料力学8_8.5c18911d.jpg";